import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { SurveyService } from 'src/app/services/survey.service';
declare var $: any;
interface SurveyOption {
  value: string;
  labelKey: string;
}

interface SurveyQuestion {
  id: string;
  questionNo: number;
  textKey: string;
  enText: string;
  type: 'rating' | 'yesno' | 'choice' | 'text';
  options?: SurveyOption[];
  required?: boolean;
  includeNA?: boolean;
}

@Component({
  selector: 'app-after-visit-survey',
  templateUrl: './after-visit-survey.component.html',
  styleUrls: ['./after-visit-survey.component.css']
})
export class AfterVisitSurveyComponent implements OnInit {
  patientpersonalinfo: any;
  checkinInfo: any;
  surveyTitle: string = '';
  isRtl: boolean = false;
  viewState: 'form' | 'thankyou' = 'form';
  thankYouTitleKey: string = 'afterVisitSurvey.thankYouTitle';
  thankYouBodyKey: string = 'afterVisitSurvey.thankYouBody';
  isAlreadySubmitted: boolean = false;
  showValidationError: boolean = false;
  ratingValues = [1, 2, 3, 4, 5];
  answers: { [key: string]: any } = {};

  questions: SurveyQuestion[] = [];

  private overallRatingQuestion: SurveyQuestion =
    { id: 'c1', questionNo: 0, textKey: 'afterVisitSurvey.q1', enText: 'Overall, how would you rate your visit today?', type: 'rating', required: true };

  private commonQuestions: SurveyQuestion[] = [
    { id: 'c2', questionNo: 0, textKey: 'afterVisitSurvey.q2', enText: 'How easy was it to schedule your appointment?', type: 'rating' },
    {
      id: 'c3', questionNo: 0, textKey: 'afterVisitSurvey.q5', enText: 'How long did you wait before being seen?', type: 'choice', options: [
        { value: 'Under 15 min', labelKey: 'afterVisitSurvey.q5_opt1' },
        { value: '15-30 min', labelKey: 'afterVisitSurvey.q5_opt2' },
        { value: '30-60 min', labelKey: 'afterVisitSurvey.q5_opt3' },
        { value: 'Over 1 hour', labelKey: 'afterVisitSurvey.q5_opt4' }
      ]
    },
    { id: 'c4', questionNo: 0, textKey: 'afterVisitSurvey.q3', enText: 'Was our staff courteous, friendly, and respectful?', type: 'rating' },
    { id: 'c6', questionNo: 0, textKey: 'afterVisitSurvey.q6', enText: 'Would you recommend us to friends or family?', type: 'yesno' },
    { id: 'c7', questionNo: 0, textKey: 'afterVisitSurvey.q7', enText: 'Any additional comments or suggestions?', type: 'text' }
  ];

  private reasonQuestionsMap: { [reasonName: string]: SurveyQuestion[] } = {
    'annual/well visit': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.annualWell.q1', enText: 'Were your health and wellness goals discussed during your visit?', type: 'yesno' },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.annualWell.q2', enText: 'Were you provided with information about recommended preventive screenings and vaccinations?', type: 'yesno', includeNA: true },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.annualWell.q3', enText: 'Did you receive information about maintaining a healthy lifestyle?', type: 'yesno' },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.annualWell.q4', enText: 'Were the next steps for your preventive care clearly communicated?', type: 'yesno' }
    ],
    'follow up visit': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.followUp.q1', enText: 'Were your updates or concerns regarding your ongoing care discussed?', type: 'yesno' },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.followUp.q2', enText: 'Were your questions about your current medications or care addressed?', type: 'yesno', includeNA: true },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.followUp.q3', enText: 'Were any changes or updates to your care plan communicated clearly?', type: 'yesno', includeNA: true },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.followUp.q4', enText: 'Were the next steps following your visit clearly explained?', type: 'yesno' }
    ],
    'initial visit': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.initial.q1', enText: 'Were you given an opportunity to share your medical history?', type: 'yesno' },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.initial.q2', enText: 'Did you feel comfortable discussing your health concerns during your first visit?', type: 'yesno' },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.initial.q3', enText: 'Were you provided with information about the practice and its care process?', type: 'yesno' },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.initial.q4', enText: 'Were the next steps after your first visit clearly explained?', type: 'yesno' }
    ],
    'sick visit': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.sick.q1', enText: 'Were your current health concerns discussed during your visit?', type: 'yesno' },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.sick.q2', enText: 'Were you provided with information about your care and recommended next steps?', type: 'yesno' },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.sick.q3', enText: 'Were you given information about when to seek further medical attention if your symptoms worsen?', type: 'yesno', includeNA: true },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.sick.q4', enText: 'Were the instructions provided after your visit clear?', type: 'yesno' }
    ],
    'injections': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.injections.q1', enText: 'Was the purpose of the injection explained to you?', type: 'yesno', includeNA: true },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.injections.q2', enText: 'Did you feel comfortable during the injection process?', type: 'yesno' },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.injections.q3', enText: 'Were your questions about the injection addressed?', type: 'yesno' },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.injections.q4', enText: 'Were you provided with instructions regarding post-injection care?', type: 'yesno', includeNA: true }
    ],
    'lab work only': [
      { id: 'r1', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.labWork.q1', enText: 'Were the required lab tests explained to you?', type: 'yesno', includeNA: true },
      { id: 'r2', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.labWork.q2', enText: 'Did you feel comfortable during the lab work process?', type: 'yesno' },
      { id: 'r3', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.labWork.q3', enText: 'Was the lab work process handled efficiently?', type: 'yesno' },
      { id: 'r4', questionNo: 0, textKey: 'afterVisitSurvey.reasonQ.labWork.q4', enText: 'Were you informed about how and when to expect your test results?', type: 'yesno', includeNA: true }
    ]
  };

  constructor(
    private router: Router,
    private _phrutilService: PhrutillsService,
    private translateService: TranslateService,
    private _surveyService: SurveyService,
    private spinner: NgxSpinnerService
  ) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this.router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(info);

    let checkinInfo = localStorage.getItem('PatientInfoCheckin');
    if (checkinInfo) {
      this.checkinInfo = this._phrutilService.decrypt(checkinInfo);
    }

    if (this.isAlreadySubmittedForThisAppointment()) {
      this.thankYouTitleKey = 'afterVisitSurvey.alreadySubmittedTitle';
      this.thankYouBodyKey = 'afterVisitSurvey.alreadySubmittedBody';
      this.isAlreadySubmitted = true;
      this.viewState = 'thankyou';
      return;
    }

    this.buildQuestions();
    this.restoreDraft();
  }

  private isAlreadySubmittedForThisAppointment(): boolean {
    try {
      const saved = localStorage.getItem(this.submittedKey);
      if (!saved) {
        return false;
      }
      const parsed = JSON.parse(saved);
      const appointmentId = this.checkinInfo?.appointment_id;
      return !!appointmentId && parsed.appointmentId === appointmentId;
    } catch (error) {
      return false;
    }
  }

  private markSubmitted() {
    const appointmentId = this.checkinInfo?.appointment_id;
    if (appointmentId) {
      localStorage.setItem(this.submittedKey, JSON.stringify({ appointmentId }));
    }
  }

  private getReasonQuestions(reasonName: string): SurveyQuestion[] {
    const name = (reasonName || '').toLowerCase();
    if (!name) {
      return [];
    }
    if (name.includes('annual') || name.includes('well')) {
      return this.reasonQuestionsMap['annual/well visit'];
    }
    if (name.includes('follow')) {
      return this.reasonQuestionsMap['follow up visit'];
    }
    if (name.includes('initial')) {
      return this.reasonQuestionsMap['initial visit'];
    }
    if (name.includes('sick')) {
      return this.reasonQuestionsMap['sick visit'];
    }
    if (name.includes('injection')) {
      return this.reasonQuestionsMap['injections'];
    }
    if (name.includes('lab')) {
      return this.reasonQuestionsMap['lab work only'];
    }
    return [];
  }

  private buildQuestions() {
    // reason-based questions disabled for now, just common questions + overall rating
    // const reasonQuestions = this.getReasonQuestions(this.checkinInfo?.reasonName) || [];
    // this.questions = [this.overallRatingQuestion, ...reasonQuestions, ...this.commonQuestions];
    this.questions = [this.overallRatingQuestion, ...this.commonQuestions];
    this.questions.forEach((q, i) => q.questionNo = i + 1);
  }

  private draftKey = 'afterVisitSurveyDraft';
  private submittedKey = 'afterVisitSurveySubmitted';

  private restoreDraft() {
    try {
      const saved = localStorage.getItem(this.draftKey);
      if (!saved) {
        return;
      }
      const parsed = JSON.parse(saved);
      const appointmentId = this.checkinInfo?.appointment_id;
      if (appointmentId && parsed.appointmentId === appointmentId) {
        this.answers = parsed.answers || {};
      }
    } catch (error) {
      console.log('error restoring survey draft ' + error);
    }
  }

  private saveDraft() {
    const appointmentId = this.checkinInfo?.appointment_id;
    localStorage.setItem(this.draftKey, JSON.stringify({ appointmentId, answers: this.answers }));
  }

  ngOnInit(): void {
    this._phrutilService.setIsSurveyPage(true);
    this._phrutilService.setIsSurveyAuthScreen(false);
    this._phrutilService.patientlanguage$.subscribe((language: string) => {
      this.isRtl = language === 'ur';
      this.buildTitle();
    });
  }

  private buildTitle() {
    // reason name in title disabled along with reason-based questions - generic title for now
    // const reason = this.checkinInfo?.reasonName;
    // if (reason) {
    //   const suffixKey = /visit\s*$/i.test(reason.trim())
    //     ? 'afterVisitSurvey.titleSuffixShort'
    //     : 'afterVisitSurvey.titleSuffix';
    //   this.translateService.get(suffixKey).subscribe((suffix: string) => {
    //     this.surveyTitle = reason + ' ' + suffix;
    //     this._phrutilService.setTitle(this.surveyTitle);
    //   });
    // } else {
      this.translateService.get('afterVisitSurvey.title').subscribe((text: string) => {
        this.surveyTitle = text;
        this._phrutilService.setTitle(text);
      });
    // }
  }

  setRating(questionId: string, value: number) {
    this.answers[questionId] = value;
    this.showValidationError = false;
    this.saveDraft();
  }

  setAnswer(questionId: string, value: any) {
    this.answers[questionId] = value;
    this.showValidationError = false;
    this.saveDraft();
  }

  isAnswered(question: SurveyQuestion): boolean {
    return this.answers[question.id] !== undefined && this.answers[question.id] !== '';
  }

  allRequiredAnswered(): boolean {
    return this.questions.filter(q => q.required).every(q => this.isAnswered(q));
  }

  submitSurvey() {
    if (!this.allRequiredAnswered()) {
      this.showValidationError = true;
      const wrapperEl = document.querySelector('.wrapper');
      if (wrapperEl) {
        wrapperEl.scrollTop = 0;
      }
      return;
    }

    const payload = {
      APPOINTMENT_ID: this.checkinInfo?.appointment_id ?? '',
      PATIENT_ACCOUNT: this.checkinInfo?.patientAccount ?? this.patientpersonalinfo?.patient_Account ?? '',
      PRACTICE_CODE: this.checkinInfo?.practiceCode ?? this.patientpersonalinfo?.practice_Code ?? '',
      RESPONSES: this.questions
        .filter(q => this.isAnswered(q))
        .map(q => ({
          QUESTION_NO: q.questionNo,
          QUESTION: q.enText.substring(0, 1000),
          ANSWER: this.answers[q.id].toString().substring(0, 8000)
        }))
    };

    this.spinner.show();
    this._surveyService.SubmitAfterVisitSurvey(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
       // console.log('SubmitAfterVisitSurvey response', res);
        //console.log('SubmitAfterVisitSurvey response', res.Message);
          const message = (res?.Message || '').toString().toLowerCase();
          if (message.includes('already been submitted')) {
            this.thankYouTitleKey = 'afterVisitSurvey.alreadySubmittedTitle';
            this.thankYouBodyKey = 'afterVisitSurvey.alreadySubmittedBody';
            this.isAlreadySubmitted = true;
          }
        
        localStorage.removeItem(this.draftKey);
        this.markSubmitted();
        this.viewState = 'thankyou';
      },
      (error: any) => {
        console.log('SavePatientFeedback error', error);
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        // need to remove below lines these for testing
       // this.thankYouTitleKey = 'afterVisitSurvey.alreadySubmittedTitle';
       // this.thankYouBodyKey = 'afterVisitSurvey.alreadySubmittedBody';
       // this.isAlreadySubmitted = true;
        localStorage.removeItem(this.draftKey);
        this.markSubmitted();
        this.viewState = 'thankyou';
      }
    );
  }

  goToAuthScreen() {
    this.router.navigateByUrl('/securelogin');
  }
}
